import { render, staticRenderFns } from "./InvoiceSummary.vue?vue&type=template&id=5b0e01e6&scoped=true&"
import script from "./InvoiceSummary.vue?vue&type=script&lang=ts&"
export * from "./InvoiceSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e01e6",
  null
  
)

export default component.exports